export default "__VITE_ASSET__rKrqUHGCQUyQJxsjUC$15w__"